import { api } from "@/lib/api";

/**
 * Phase 15b — Self-paced Learning Paths (student-owned courses).
 * All endpoints require the caller to be an approved student.
 */

export const generateLearningPath = ({
  topic,
  num_chapters = 3,
  self_description = "",
  interests = [],
}) =>
  api
    .post(`/student/learning-paths/generate`, {
      topic,
      num_chapters,
      self_description,
      interests,
    })
    .then((r) => r.data);

export const listLearningPaths = () =>
  api.get(`/student/learning-paths`).then((r) => r.data);

export const getLearningPath = (courseId) =>
  api.get(`/student/learning-paths/${courseId}`).then((r) => r.data);

export const deleteLearningPath = (courseId) =>
  api.delete(`/student/learning-paths/${courseId}`).then((r) => r.data);

export const regenerateChapter = (courseId, chapterId, instructions = "") =>
  api
    .post(
      `/student/learning-paths/${courseId}/chapters/${chapterId}/regenerate`,
      { instructions }
    )
    .then((r) => r.data);

/** Reuse the existing course-generation polling endpoint. */
export const getGenerationStatus = (courseId) =>
  api.get(`/courses/${courseId}/ai-generation`).then((r) => r.data);

// ---------- Display helpers ----------

export const ageBucketLabel = (b) =>
  ({ kid: "Kid mode", teen: "Teen mode", adult: "Adult mode" }[b] || b || "—");

export const ageBucketClass = (b) =>
  ({
    kid: "bg-sky-100 text-sky-800 border-sky-300",
    teen: "bg-violet-100 text-violet-800 border-violet-300",
    adult: "bg-stone-100 text-stone-800 border-stone-300",
  }[b] || "bg-stone-100 text-stone-700 border-stone-300");

export const sensitiveBucketLabel = (b) =>
  ({
    mental_health: "Mental health · supportive",
    geopolitics: "Geopolitics · framed",
    religion: "Religion · framed",
  }[b] || null);

export const generationStatusLabel = (s) =>
  ({
    queued: "Queued",
    running: "Generating…",
    done: "Ready",
    failed: "Failed",
  }[s] || s);

export const generationStatusClass = (s) =>
  ({
    queued: "bg-stone-100 text-stone-700 border-stone-300",
    running: "bg-amber-100 text-amber-900 border-amber-300",
    done: "bg-emerald-100 text-emerald-800 border-emerald-300",
    failed: "bg-red-100 text-red-800 border-red-300",
  }[s] || "");
